import type { CategoryContent } from '../row.js';

export const AUSTRIAN_HISTORY: CategoryContent = {
  bscba: [
    [
      'Welke dynastie regeerde Oostenrijk voordat de Habsburgers aan het einde van de 13e eeuw aan de macht kwamen?',
      [
        'Babenberg',
        'Salisch',
        'Ottonisch',
        'Karolingisch',
      ],
      0,
      'De Babenbergers regeerden de Mark en het Hertogdom Oostenrijk van ongeveer 976 tot 1246, toen het geslacht uitstierf. De Habsburgers werden later de dominante dynastie.',
    ],
    [
      'In welk jaar ontbond het Austro-Hongaarse Rijk zich formeel?',
      [
        '1918',
        '1920',
        '1919',
        '1922',
      ],
      0,
      'Oostenrijk-Hongarije stortte in 1918 in na de nederlaag in de Eerste Wereldoorlog. Het Verdrag van Saint-Germain in 1919 beëindigde het rijk formeel.',
    ],
    [
      'Wie was de laatst regerende keizer van Oostenrijk-Hongarije?',
      [
        'Franciscus Jozef',
        'Karel I',
        'Maximiliaan I',
        'Ferdinand I',
      ],
      0,
      'Karel I was de laatste keizer en regeerde van 1916 tot zijn abdicatie in november 1918, toen het rijk instortte.',
    ],
    [
      'In welk jaar verklaarde Oostenrijk zich republiek na de ondergang van het rijk?',
      [
        '1918',
        '1919',
        '1920',
        '1917',
      ],
      0,
      'Oostenrijk verklaarde zich in 1918 tot federale republiek na de ontbinding van Oostenrijk-Hongarije. Deze staat wordt de Eerste Oostenrijkse Republiek genoemd.',
    ],
    [
      'Wat was de belangrijkste politieke gebeurtenis in Oostenrijk in 1938?',
      [
        'Anschluss met nazi-Duitsland',
        'Onafhankelijkheidsverklaring van Hongarije',
        'Restauratie van de Habsburgse monarchie',
        'Verkiezing van de eerste republikeinse president',
      ],
      0,
      'De Anschluss verenigde Oostenrijk in maart 1938 met nazi-Duitsland. Daarmee kwam een einde aan de Oostenrijkse onafhankelijkheid tot na de Tweede Wereldoorlog.',
    ],
    [
      'Wat was de hoofdstad van het middeleeuwse Hertogdom Oostenrijk onder Babenbergse heerschappij?',
      [
        'Wenen',
        'Salzburg',
        'Graz',
        'Linz',
      ],
      0,
      'Wenen was de hoofdstad van het Hertogdom Oostenrijk onder de Babenbergers en bleef daarna de voornaamste Habsburgse zetel.',
    ],
    [
      'Welk verdrag verdelde Oostenrijk-Hongarije formeel na de Eerste Wereldoorlog?',
      [
        'Saint-Germain',
        'Verdrag van Versailles',
        'Verdrag van Trianon',
        'Verdrag van Brest-Litovsk',
      ],
      0,
      'Het Verdrag van Saint-Germain (1919) ontbond Oostenrijk-Hongarije formeel en stelde Oostenrijk in als kleine onafhankelijke republiek.',
    ],
    [
      'In welk jaar herkwam Oostenrijk volledige soevereiniteit en verklaarde het permanente neutraliteit?',
      [
        '1955',
        '1945',
        '1950',
        '1960',
      ],
      0,
      'Oostenrijk herkwam volledige onafhankelijkheid in 1955 en verklaarde tegelijkertijd eeuwige neutraliteit, die internationaal werd erkend.',
    ],
    [
      'Welke godsdienst domineerde het Oostenrijkse Rijk gedurende het grootste deel van zijn geschiedenis?',
      [
        'Rooms-katholicisme',
        'Luthers protestantisme',
        'Oost-orthodoxie',
        'Calvinisme',
      ],
      0,
      'De Oostenrijkse Habsburgse staat was overwegend katholiek, en het katholicisme bleef centraal staan in de Oostenrijkse identiteit en het bestuur.',
    ],
    [
      'Welke regio was de originele machtsbasis van de Babenberg-dynastie?',
      [
        'De Mark Oostenrijk',
        'De Alpenvallei van Tirol',
        'De vlaktes van Moravië',
        'De bossen van Bohemen',
      ],
      0,
      'De Babenbergers begonnen als markgraven van de Mark Oostenrijk, een grensgebied langs de Donau dat als verdedigingsbuffer diende.',
    ],
    [
      'In welk jaar trad Oostenrijk toe tot de Europese Unie?',
      [
        '1995',
        '1992',
        '2000',
        '1998',
      ],
      0,
      'Oostenrijk trad in 1995 toe tot de Europese Unie. Hiermee kwam, via het lidmaatschap, in aangepaste vorm een einde aan decennia van officiële neutraliteit.',
    ],
    [
      'Hoe heette de Oostenrijkse staat na de Eerste Wereldoorlog en vóór de Tweede Wereldoorlog?',
      [
        'Eerste Oostenrijkse Republiek',
        'Tweede Oostenrijkse Republiek',
        'Oostenrijkse Confederatie',
        'Oostenrijkse Federale Staat',
      ],
      0,
      'De periode van 1918 tot 1938 staat bekend als de Eerste Oostenrijkse Republiek, eindigend met nazi-annexatie.',
    ],
    [
      'Welke grote Europese stad was gedurende het Habsburgse tijdperk de hoofdstad van Oostenrijk?',
      [
        'Wenen',
        'Praag',
        'Boedapest',
        'Triëst',
      ],
      0,
      'Wenen was de hoofdstad van het aartshertogdom en later van het keizerrijk. De stad was de voornaamste zetel van de Habsburgse dynastie.',
    ],
    [
      'Welke gebeurtenis in 1246 beëindigde de Babenbergse regering in Oostenrijk?',
      [
        'Dood van de laatste Babenbergse hertog',
        'Invasie door Hongaarse troepen',
        'Verovering door de heilige Roomse keizer',
        'Boerenopstand',
      ],
      0,
      'De dood van hertog Frederik II (Frederik de Krijger) in 1246 beëindigde de Babenbergse lijn, wat tot een strijd om de erfopvolging leidde.',
    ],
    [
      'Hoe bevrijdde Oostenrijk zich van nazi-bezetting na de Tweede Wereldoorlog?',
      [
        'Bevrijd door geallieerde troepen, later neutraal',
        'Het werd onmiddellijk verdeeld onder nabuurlanden',
        'Het bleef verdeeld als Duitsland tot 1990',
        'Oostenrijk verenigde zich vrijwillig met West-Duitsland',
      ],
      0,
      'Geallieerde troepen bevrijdden Oostenrijk tussen 1944 en 1945. Het Oostenrijkse Staatsverdrag (1955) herstelde de onafhankelijkheid, met verplichte neutraliteit.',
    ],
  ],
  msc: [
    [
      'In welk jaar vestigde Leopold V, de Babenbergse markgraaf, zijn lijn als onafhankelijke heersers, los van het rechtstreekse gezag van de heilige Roomse keizer?',
      [
        '976',
        '1018',
        '1055',
        '1122',
      ],
      0,
      'Leopold I (Liutpold) stichtte rond 976 de Babenberg-dynastie als markgraaf van de Mark Oostenrijk onder nominale keizerlijke suzereiniteit.',
    ],
    [
      'Welke constitutionele regeling karakteriseerde de relatie tussen Oostenrijk en Hongarije in het door het Austro-Hongaarse Compromis ingestelde rijk?',
      [
        'Duaal koningschap met twee kronen',
        'Eenheidsstaat met Boedapest als enige hoofdstad',
        'Confederatie onder een enig parlement',
        'Persoonlijke unie zonder gedeelde soevereiniteit',
      ],
      0,
      'De Ausgleich (Compromis) van 1867 creëerde een duaal koningschap met Oostenrijk en Hongarije als gelijke staten, die alleen op het gebied van buitenlandse zaken samenwerkten.',
    ],
    [
      'Welke Habsburgse keizer convoceerde het Congres van Wenen, dat Europa na de Napoleontische Oorlogen reorganiseerde?',
      [
        'Franciscus I',
        'Jozef II',
        'Leopold II',
        'Karel VI',
      ],
      0,
      'Keizer Franciscus I organiseerde via zijn minister van buitenlandse zaken Metternich het Congres van Wenen in 1815.',
    ],
    [
      'Wat was de voornaamste reden dat de Eerste Oostenrijkse Republiek in 1919 een federaal regeringsstelsel aannam?',
      [
        'Om de macht tussen Wenen en de regio\'s in evenwicht te brengen',
        'Omdat het verdrag het als vredesverplichting vereiste',
        'Om voorbereiding op vereniging met Duitsland',
        'Om te voldoen aan de lidmaatschapseisen van de Volkenbond',
      ],
      0,
      'Oostenrijks federale structuur verdeelde de macht over de deelstaten, als compensatie voor het drastisch verminderde grondgebied en de kleinere bevolking.',
    ],
    [
      'Welke muzikale en culturele beweging was nauw verbonden met laat-19e-eeuws Wenen onder Habsburgse heerschappij?',
      [
        'De Weense Wals-traditie',
        'Impressionisme in schilderkunst',
        'Romantisch nationalisme in literatuur',
        'Duits expressionistisch theater',
      ],
      0,
      'De wals en componisten als Johann Strauss II belichaamden het wereldwijde culturele prestige en de verfijnde hofcultuur van Wenen.',
    ],
    [
      'In welk jaar annexeerde het nazi-regime Oostenrijk, en wat was de officiële Duitse term voor deze handeling?',
      [
        '1938; Anschluss',
        '1936; Lebensraum',
        '1940; Reichsgaue',
        '1935; Gleichschaltung',
      ],
      0,
      'De Anschluss (unie/verbinding) van 1938 absorbeerde Oostenrijk in het Duitse Rijk onder Hitler, wat onafhankelijkheid beëindigde.',
    ],
    [
      'Welke van het volgende was geen grote etnische groep die onafhankelijkheid of autonomie in Oostenrijk-Hongarije aan het begin van de 20e eeuw nastreefde?',
      [
        'Vlaamse',
        'Polen',
        'Roemenen',
        'Zuid-Slavische',
      ],
      0,
      'Vlaams nationalisme was verbonden aan België, niet aan Oostenrijk-Hongarije. Polen, Roemenen en Zuid-Slavische groepen streefden in het rijk autonomie na.',
    ],
    [
      'Wat was het Metternich-Systeem, en welk tijdperk domineerde het?',
      [
        'Conservatieve orde ingesteld in 1815-1848',
        'Oostenrijkse parlementaire democratie van 1867-1914',
        'Habsburgse militaire strategie gebruikt tegen Pruisen',
        'Economische unie tussen Oostenrijk en Duitsland',
      ],
      0,
      'Klemens von Metternichs diplomatieke systeem handhaafde conservatieve orde en Oostenrijkse hegemonie in Centraal-Europa tot 1848.',
    ],
    [
      'Waarom verklaarde Oostenrijk in 1914 onwillig de oorlog aan Servië, wat de Eerste Wereldoorlog op de Balkan initieerde?',
      [
        'Moord op aartshertog Frans Ferdinand',
        'Uitbreiding van territoriale claims op de Balkan',
        'Verbondenheidsplicht aan Duitse invasie van België',
        'Maritieme blokkade opgelegd door Groot-Brittannië',
      ],
      0,
      'De moord op erfgenaam Frans Ferdinand in juni 1914 leidde tot Oostenrijks ultimatum aan Servië en veroorzaakte de Eerste Wereldoorlog.',
    ],
    [
      'In welke economische en handelsblok trad Oostenrijk in 1972 toe, wat een verschuiving naar Westeuropese integratie weerspiegelde?',
      [
        'Europese Vrijhandelsbond (EFTA)',
        'Europese Economische Gemeenschap (EEG)',
        'COMECON',
        'Benelux-Unie',
      ],
      0,
      'Oostenrijk trad in 1972 tot de EFTA toe en bouwde zo handelsrelaties met West-Europa op. Het land gaf daarbij zijn officiële neutraliteit tijdens de Koude Oorlog niet op.',
    ],
    [
      'Welk middeleeuwse juridische voorrecht verhief Oostenrijk van markgraafschap tot hertogdom met speciale status?',
      [
        'Privilegium Minus',
        'Gouden Bul van 1222',
        'Magna Carta van 1215',
        'Vrede van Westfalen',
      ],
      0,
      'Het Privilegium Minus (1156) verleende Oostenrijk onafhankelijkheid van Beiers oppergezag en stelde het in als hertogdom onder keizerlijke bescherming.',
    ],
    [
      'Welke rol speelde het Oostenrijkse Staatsverdrag van 1955 bij beëindiging van bezetting na de Tweede Wereldoorlog?',
      [
        'Herstelde soevereiniteit in ruil voor neutraliteit',
        'Verdeelde Oostenrijk in aparte zones onder Sovjet- en westerse controle',
        'Vereiste onmiddellijk NAVO-lidmaatschap',
        'Overdroeg Tirol permanent aan Italië',
      ],
      0,
      'Het Oostenrijkse Staatsverdrag van 1955 herstelde volledige onafhankelijkheid en soevereiniteit met verplichte neutraliteit.',
    ],
    [
      'Welke grote hervorming voerde keizer Jozef II door, waarmee hij het keizerrijk moderniseerde maar ook destabiliseerde?',
      [
        'Verlicht absolutisme',
        'Feodale decentralisering naar lokale adel',
        'Democratisering via algemeen kiesrecht',
        'Verzwakking van de invloed van het katholicisme',
      ],
      0,
      'Jozef II\'s verlichte absolutisme centraliseerde het gezag, maar vervreemdde de adel en etnische groepen, wat instabiliteit op lange termijn veroorzaakte.',
    ],
    [
      'Welke Babenberg-heerser verhief Wenen tot prominentie als belangrijk handels- en strategisch centrum aan de Donau?',
      [
        'Hendrik II Jasomirgott',
        'Leopold de Glorieuze',
        'Albert de Wijze',
        'Frederik de Krijger',
      ],
      0,
      'Hendrik II Jasomirgott (1141-1177) maakte Wenen zijn hoofdstad en verleende de stad uitgebreide handelsrechten, waardoor Wenen uitgroeide tot een belangrijk centrum.',
    ],
    [
      'Waarom werd de Eerste Oostenrijkse Republiek in 1919 aanvankelijk verhinderd zich met Duitsland te verenigen, een doel dat veel Oostenrijkers nastreefden?',
      [
        'Het Verdrag van Saint-Germain verbood het',
        'Oostenrijk koos ervoor vrijwillig onafhankelijk te blijven',
        'Duitsland weigerde de unificatievoorstellen',
        'De Volkenbond verbood het',
      ],
      0,
      'Het Verdrag van Saint-Germain (1919) verbood de Anschluss ter voorkoming van Duitse dominantie, wat later door nazi-Duitsland werd geschonden.',
    ],
  ],
  phd: [
    [
      'Het Privilegium Minus van 1156 verhief Oostenrijks status vooral om welk strategisch doel voor de heilige Roomse keizer te bereiken?',
      [
        'Een bufferstaat tegen Beieren en Hongarije',
        'Centraliseerde Duitse macht tegen Franse agressie',
        'Stelde tegenmacht tegen pauselijke gezag in Italië in',
        'Verschafte marinebasis voor Middellandse-Zeehandel',
      ],
      0,
      'Het privilege beloonde Babenbergse militaire diensten, terwijl de onafhankelijke Mark Oostenrijk als strategische grenswacht werd ingesteld.',
    ],
    [
      'Hoe droeg de etnische samenstelling en nationalistische bewegingen in Oostenrijk-Hongarije bij tot uiteindelijke ontbinding?',
      [
        'Concurrerende etnische claims fragmenteerden het rijk',
        'Etnische homogeniteit veroorzaakte paradoxaal genoeg stagnatie en burgeroorlog',
        'Het rijk had geen nationalistische bewegingen voor 1914',
        'Nationalisme was geheel een externe uitvinding van de verdragslanden',
      ],
      0,
      'Slavische, Hongaarse, Roemeense en andere groepen streefden decennialang autonomie na. De WOI-verliezen versnelden centrifugale krachten tot volledige afscheiding.',
    ],
    [
      'Welk historiografisch debat omringt Jozef II\'s regering aangaande bestuurscentralisatie en etnische spanningen?',
      [
        'Of zijn hervormingen het rijk versterkten of destabiliseerden',
        'Of hij meer door de Verlichting of door Contrareformatie-ideologie werd beïnvloed',
        'Of hij opzettelijk de ontbinding van het keizerrijk plande',
        'Of zijn militaire campagnes strategisch zuiver waren',
      ],
      0,
      'Geschiedkundigen debatteren of Jozef\'s rationaliserende absolutisme een noodzakelijke modernisering was of een katalysator voor nationalistische wrok.',
    ],
    [
      'Het Austro-Hongaarse Compromis van 1867 creëerde duaal koningschap deels als reactie op welke militaire nederlaag?',
      [
        'Pruisische overwinning in de Zevenweken-Oorlog',
        'Ottomaanse verovering van Hongarije in 1526',
        'Napoleontische overwinningen onder het Franse Rijk',
        'Britse maritieme dominantie in mondiale handel',
      ],
      0,
      'Oostenrijks verlies aan Pruisen in 1866 dwong tot hervorming. De Ausgleich verhief Hongarije tot gelijke status, om de stabiliteit te handhaven.',
    ],
    [
      'Welk aspect van de positie van Wenen als keizerlijke hoofdstad versterkte de Oostenrijkse culturele en diplomatieke invloed, ondanks de dalende militair-economische macht na 1870?',
      [
        'De rol van Wenen als kosmopolitisch intellectueel centrum',
        'Ligging op centrale handelsroutes als waarborg voor commerciële dominantie',
        'Directe militaire controle over de Middellandse Zee',
        'Exclusieve alliantie met Groot-Brittannië en Frankrijk',
      ],
      0,
      'Het culturele prestige van Wenen — muziek, filosofie, psychologie, literatuur — handhaafde de Habsburgse zachte macht, ondanks de groeiende Pruisische dominantie.',
    ],
    [
      'Hoe hervormde de ontbinding van Oostenrijk-Hongarije in 1918 de politieke kaart van Centraal-Europa, en welk beginsel regelde de territoriale verdelingen?',
      [
        'Zelfbepaling creëerde nieuwe natiestaten',
        'Overwinnaars herverdeelden grondgebied als verovering',
        'Oostenrijk en Hongarije bleven intact maar als bezette kolonies',
        'Geen significante grensveranderingen vonden plaats',
      ],
      0,
      'De verdragen van 1919 pasten zelfbepaling inconsistent toe. Daardoor ontstonden staten als Tsjechoslowakije en Joegoslavië met grote minderheden.',
    ],
    [
      'Waarom nam Oostenrijk in zijn grondwet van 1920 een quasi-presidentieel federaal systeem aan, in plaats van een zuiver parlementair systeem?',
      [
        'Om uitvoerende stabiliteit te creëren',
        'Omdat de verdragslanden dit oplegden',
        'Omdat Oostenrijk altijd presidentiële systemen gebruikte',
        'Ter voorbereiding op vereniging met Duitsland',
      ],
      0,
      'Een krachtige presidentiële macht was bedoeld om uitvoerende continuïteit te waarborgen. Toch bleven er grondwettelijke conflicten bestaan tussen het parlement en de president.',
    ],
    [
      'Wat was de Ständestaat, en hoe vertegenwoordigde het Oostenrijks streven nazi- en Sovjet-invloed in de jaren 30 af te weren?',
      [
        'Austro-fascistische korporatieve staat onder Dollfuß',
        'Socialistische arbeidersbeweging tegen nazi-expansie',
        'Restauratie van de Habsburgse monarchie in ballingschap',
        'Internationale pacifistische organisatie',
      ],
      0,
      'De Ständestaat van 1934-1938 onder Dollfuß streefde katholiek autoritair alternatief voor zowel nazi-totalitarisme als communisme na.',
    ],
    [
      'Hoe onderscheidde de Oostenrijkse verzetsbeweging zich van verzet in andere bezette gebieden?',
      [
        'Beperkt door ambiguïteit over Oostenrijkse identiteit',
        'Het was niet-bestaand en Oostenrijk volledig collaboreerde',
        'Oostenrijkers bevrijdden zich onmiddellijk zonder externe hulp',
        'Oostenrijk had uniform verzet onder alle politieke groepen',
      ],
      0,
      'De complexe relatie van de Oostenrijkers met de Anschluss van 1938 (sommigen verwelkomden die) fragmenteerde het verzet tijdens de bezetting in de Tweede Wereldoorlog.',
    ],
    [
      'Welke rol speelde de Oostenrijkse Communistische Partij in de naoorlogse Tweede Republiek, en waarom bleef zij marginaal ondanks de Sovjetbezetting?',
      [
        'Zwak door katholieke identiteit',
        'Zij greep onmiddellijk na 1945 macht',
        'Oostenrijk had geen communistische aanwezigheid',
        'De communistische partij domineerde de naoorlogse politiek',
      ],
      0,
      'Hoewel de Sovjets Oost-Oostenrijk bezetten, beperkten het Oostenrijkse katholicisme en de banden met het Westen de communistische winst. Het verdrag van 1955 verminderde de Sovjetinvloed verder.',
    ],
    [
      'Hoe kon Oostenrijks militaire neutraliteit na de oorlog het toestaan om in 1995 tot de EU toe te treden zonder ook bij de NAVO aan te sluiten?',
      [
        'EU-lidmaatschap is verenigbaar met militaire neutraliteit',
        'Oostenrijk sloot zich in 1995 heimelijk aan bij de NAVO',
        'Neutraliteit en EU-lidmaatschap zijn contradictoir; Oostenrijk schond zijn verdrag',
        'Oostenrijk is eigenlijk geen EU-lid',
      ],
      0,
      'Het Oostenrijkse Staatsverdrag van 1955 beperkte de neutraliteit tot militaire niet-betrokkenheid. EU-lidmaatschap (economisch en politiek) staat daar niet haaks op.',
    ],
    [
      'Hoe hangt de ineenstorting van het Metternich-systeem in 1848 samen met de nationalistische en liberale opstanden in de Habsburgse gebieden?',
      [
        'Revoluties overweldigden Metternich\'s systeem',
        'Revoluties vonden niet in Oostenrijk plaats',
        'Metternich verhinderde met succes alle hervorming',
        'Nationalisme ontstond niet vóór 1900',
      ],
      0,
      'Opstanden verspreidden zich in 1848 door het hele rijk en daagden zowel het autocratisme als de multinationale hegemonie uit. Hoewel ze werden onderdrukt, bleek hieruit de kwetsbaarheid van het systeem.',
    ],
    [
      'Welke intellectuelen en bewegingen die in Wenen gecentreerd waren tijdens de late 19e en vroege 20e eeuw, gelden als grondleggers van het moderne denken?',
      [
        'Freud, Mahler, Schönberg en de Weense Kring',
        'Alleen politieke theoretici waren belangrijk voor de invloed van Wenen',
        'Wenen produceerde geen significante denkers',
        'Al het belangrijke modernisme ontstond in Duitsland',
      ],
      0,
      'Wenen was een knooppunt van psychologische, muzikale, filosofische en artistieke innovatie, die het 20e-eeuwse intellectuele leven wereldwijd hervormde.',
    ],
    [
      'Hoe vormde Oostenrijks geografische ligging tussen Duitse en Ottomaanse Balkansferen zijn middeleeuwse ontwikkeling onder de Babenbergers?',
      [
        'Grensligging vereiste militaire kracht en allianties',
        'Geografie was irrelevant voor Oostenrijkse ontwikkeling',
        'Oostenrijk stond altijd onder Ottomaanse heerschappij',
        'Oostenrijk had geen strategisch belang',
      ],
      0,
      'De Donaugang en keizerlijke banden vestigden Wenen als vitale grenspost en militaire sterkte, wat de Babenbergse expansie aandreef.',
    ],
    [
      'Welke historiografische herbeoordeling is er ontstaan over Oostenrijkse medeplichtigheid aan nazi-misdaden en het naoorlogse narratief van Oostenrijk als "eerste slachtoffer"?',
      [
        'Oostenrijkse medeplichtigheid overtreft slachtofferstatus',
        'Oostenrijk was geheel medeplichtig zonder slachtoffelementen',
        'Oostenrijk was geheel onschuldig zonder collaboratie',
        'Historisch debat over dit onderwerp bestaat niet',
      ],
      0,
      'Sinds de jaren tachtig hebben historici het "slachtoffer"-narratief betwist, en daarbij aanzienlijke nazi-steun en deelname aan Oostenrijkse oorlogsmisdaden gedocumenteerd.',
    ],
  ],
  professor: [
    [
      'In de historiografie van de Babenberg-dynastie, welk bewijs betwist het traditionele narratief van continue territoriale expansie, en hoe herzien moderne geleerden de periodisering?',
      [
        'Niet-lineaire consolidatie met terugvallen',
        'Geen bewijs betwist expansie-narratief',
        'Babenbergers hadden minimale territoriale controle',
        'Expansie was continu en onbetwist',
      ],
      0,
      'Paleografische en cartografische heranalyse toont dat het "markgraafschap" gefragmenteerd was. De consolidatie verliep langzamer en met meer strijd dan de traditionele historiografie beweerde.',
    ],
    [
      'Hoe herkaderen postkoloniale en transnationale benaderingen de interne diversiteit van Oostenrijk-Hongarije, voorbijgaand aan de metafoor van de "gevangenis van volkeren"?',
      [
        'Actorschap, hybriditeit en gedeelde keizerlijke structuren',
        'Postkoloniale theorie is onrelevant voor Oostenrijk-Hongarije',
        '"Gevangenis van volkeren" blijft het enige juiste kader',
        'Oostenrijk-Hongarije was geheel homogeen',
      ],
      0,
      'Recent wetenschappelijk onderzoek (Judson, Rozenblit) benadrukt een gedeeld keizerlijk project, elitair kosmopolitisme en onderhandelde identiteiten, boven lineaire onderdrukking.',
    ],
    [
      'Welke rol speelde het gemeenschappelijke Austro-Hongaarse leger bij de handhaving van de keizerlijke samenhang, en hoe destabiliseerden taalkundige en nationale loyaliteitsspanningen dit leger?',
      [
        'Een integratief instituut onder druk van massapolitiek',
        'Het leger had geen interne spanningen',
        'Het leger was uit slechts één etnische groep samengesteld',
        'Taalkundige verschillen beïnvloedden het functioneren van het leger niet',
      ],
      0,
      'Het k.u.k.-leger symboliseerde de keizerlijke eenheid, maar kreeg tijdens de Eerste Wereldoorlog te maken met toenemende muiterij, desertie en bevelsverwarring, doordat de nationale loyaliteit van soldaten zwaarder woog dan hun keizerlijke plicht.',
    ],
    [
      'Hoe betwisten revisionistische geschiedschrijvers van de overgangsperiode 1918-1920 het idee van een onvermijdelijke ineenstorting, en welk toeval had de uitkomsten kunnen veranderen?',
      [
        'Mislukt federalisme en diplomatieke misstappen',
        'De ineenstorting was volledig onvermijdelijk, zonder enig toeval',
        'Historici hebben de overgangsperiode niet bestudeerd',
        'Slechts één uitkomst was mogelijk',
      ],
      0,
      'Geleerden (Suppan, Taylor) discussiëren over de vraag of federale en grondwettelijke hervormingen het rijk hadden kunnen stabiliseren. De ineenstorting vloeide deels voort uit politieke misrekeningen.',
    ],
    [
      'Op welke manieren beïnvloedde de territoriale inkrimping van de Eerste Oostenrijkse Republiek de nationale identiteitsconstructie, en hoe ontstonden concurrerende visies op "Oostenrijksheid"?',
      [
        'Een identiteitsvacuüm van concurrerende visies',
        'Oostenrijkse identiteit was voor 1918 vast ingesteld',
        'Er was geen identiteitsdebat in de republiek',
        'Alle Oostenrijkers waren het op nationale identiteit eens',
      ],
      0,
      'De republiek worstelde met de spanning tussen een Duitse nationale identiteit (aansluiting bij Weimar), katholiek korporatisme en een eigen Oostenrijks patriottisme. Deze fragmentatie maakte de aantrekkingskracht van het nazisme mede mogelijk.',
    ],
    [
      'Hoe verschilt recente transnationale geschiedschrijving over antisemitisme in Oostenrijk van eerdere verslagen die de schuld uitsluitend bij externe nazificatie legden?',
      [
        'Inheems antisemitisme van vóór Hitler',
        'Oostenrijk had geen antisemitische traditie vóór het nazisme',
        'Antisemitisme begon enkel met Hitlers aankomst',
        'Oostenrijk was geheel vrij van religieus vooroordeel',
      ],
      0,
      'Historici (Rozenblit, Pollack) traceren het 19e-eeuwse Oostenrijks-Hongaarse antisemitisme terug tot Luegers Wenen. Het nazisme kapitaliseerde op deze reeds bestaande vijandigheid.',
    ],
    [
      'Welk historiografisch debat omringt de Oostenrijkse Anschluss van 1938: moet die worden gelezen als annexatie, nationale eenwording, of als iets complexers?',
      [
        'Dwang, manipulatie en verdeelde opinie',
        'De Anschluss genoot unanieme populaire steun',
        'Het was puur een buitenlandse verovering zonder Oostenrijkse deelname',
        'Er bestaat geen geleerd debat over dit onderwerp',
      ],
      0,
      'Revisionistische geschiedschrijving sinds de jaren tachtig (Hanisch, Botz) compliceert vroegere "slachtoffer"-narratieven en documenteert daarbij aanzienlijke nazi-steun, ondanks de dwingende maatregelen.',
    ],
    [
      'Hoe navigeerden de Oostenrijkse katholieke intellectuele tradities de ideologische crisis van de jaren 1920-1930, in het bijzonder het kerkelijke antwoord op communisme en fascisme?',
      [
        'Een katholieke derde weg naar autoritarisme',
        'De Katholieke Kerk bleef gedurende deze periode politiek neutraal',
        'Het katholicisme had geen invloed op de Oostenrijkse politiek',
        'De Kerk steunde uitsluitend de democratie',
      ],
      0,
      'Het Oostenrijks-katholieke denken ontwikkelde korporatieve alternatieven voor liberale democratie en socialisme. De kerksteun voor Dollfuß\' Ständestaat weerspiegelde deze koers.',
    ],
    [
      'Welke rol speelden de intellectuele gemeenschappen van Wenen (de Weense Kring, de Tweede Weense School, Freudiaanse kringen) bij het voortbrengen van intellectuelen in ballingschap, die de naoorlogse wederopbouw door de geallieerden mede vormgaven?',
      [
        'Gedwongen emigratie vormde het bezettingsbeleid',
        'Wenen had geen intellectuele invloed op de naoorlogse planning',
        'Emigratie had geen effect op het geallieerde beleid',
        'Weense intellectuelen bleven in Oostenrijk',
      ],
      0,
      'Ballingschap-Oostenrijkers in geallieerde dienst (Morgenstern, Helmer) hielpen het bezettingsbeleid mede vormgeven. Culturele emigratienetwerken beïnvloedden hoe de geallieerden de naoorlogse rol van Oostenrijk begrepen.',
    ],
    [
      'Op welke manier vertegenwoordigt het Oostenrijkse Staatsverdrag (1955) een bijzondere Koude Oorlog-regeling, en hoe verschillen de Sovjetconcessies van de Duitse en Koreaanse verdelingen?',
      [
        'Consensuele terugtrekking, geen verdeling',
        'Oostenrijk was verdeeld als Duitsland',
        'De Sovjets bereikten territoriale concessies',
        'Het verdrag loste niets op',
      ],
      0,
      'Het verdrag van 1955 vormt een anomalie: de Sovjets aanvaardden de Oostenrijkse onafhankelijkheid met verplichte neutraliteit, in plaats van voortgezette verdeling of satellietstatus zoals in Duitsland.',
    ],
    [
      'Hoe verklaren historici de betrekkelijk vredige naoorlogse transitie van Oostenrijk en de snelle integratie in democratische westerse structuren, vergeleken met andere opvolgerstaten?',
      [
        'Katholieke consensus en Marshall-steun',
        'Oostenrijk stond grotere uitdagingen dan andere staten',
        'De transitie was geheel vredig zonder moeilijkheden',
        'Oostenrijk integreerde niet in westerse structuren',
      ],
      0,
      'Oostenrijks katholiek-socialistische grote coalitie (1945-1966) en westerse Koude Oorlog-steun overwonnen de denazificatiespanningen. De naoorlogse consensus maakte een snellere stabilisatie mogelijk.',
    ],
    [
      'Welke interpretatieve kaders hebben geleerden toegepast ter begrijping van Habsburgse monarchie\'s lange overleving (ruwweg 1282-1918) relatief aan andere Europese imperia?',
      [
        'Dynastieke veerkracht en huwelijksallianties',
        'Habsburgers hadden geen speciale voordelen',
        'Enkel militaire kracht handhaafde de monarchie',
        'Het Habsburgse rijk stond altijd op rand van ineenstorting',
      ],
      0,
      'Historici benadrukken adaptieve bestuur, internationaal-elite gedeelde investering in keizerrijk en Habsburgers\' strategische huwelijksstrategie als structurele handhavers.',
    ],
    [
      'Hoe is het concept "supernationalisme" van toepassing op laat Oostenrijk-Hongarije, en welke grondwettelijke hervormingen van 1914-1918 beoogden de waarde ervan te behouden?',
      [
        'Popovici\'s federalisme-plan voor "Groter-Oostenrijk"',
        'Supernationalisme had geen relevantie voor Oostenrijk-Hongarije',
        'Er bestonden geen grondwettelijke hervormingsprojecten',
        'De oorlog begon met grondwettelijke consensus',
      ],
      0,
      'Intellectuelen uit de vooroorlogse en oorlogsjaren bedachten federale supranationale structuren. Deze bleven onverwezenlijkt doordat nationalistische partijen compromis afwezen en de militaire nederlaag de opties uiteindelijk sloot.',
    ],
    [
      'Waarnaar verwijst de "Oostenrijkse kwestie" in de Koude Oorlog-diplomatieke geschiedenis, en waarom werden de Oostenrijkse hereniging en neutralisering als model of precedent behandeld?',
      [
        'Een sjabloon voor Duitse hereniging, nooit toegepast',
        'Er was geen Oostenrijkse kwestie in de Koude Oorlog-diplomatie',
        'De status van Oostenrijk had geen diplomatieke betekenis',
        'De Oostenrijkse situatie loste de Duitse kwestie rechtstreeks op',
      ],
      0,
      'De Oostenrijkse regeling van 1955 suggereerde dat verdeling via onderhandeling en neutraliteit kon worden teruggedraaid. De starheid van de Koude Oorlog verhinderde echter dat dit model werd toegepast op Duitsland of Korea.',
    ],
    [
      'Hoe hebben milieu- en ruimtehistorici de rol van Wenen in het Habsburgse Rijk geherkaderd, met name met betrekking tot grondstofstromen, infrastructuur en stadsuitbreiding als keizerlijke hoofdstad?',
      [
        'De groei van Wenen steunde op keizerlijke hulpbronnen',
        'De ontwikkeling van Wenen was puur intern',
        'De stad had minimaal keizerlijk belang',
        'Infrastructuur speelde geen rol in de keizerlijke macht',
      ],
      0,
      'Recente milieugeschiedenis (Orban) traceert de voedsel- en energieafhankelijkheid van Wenen van Donaugraan en provinciale hulpbronnen, en koppelt de stedelijke expansie aan keizerlijke dominantie.',
    ],
  ],
};
